export const marcTagDescriptions = {
  LDR: "Leader - Fixed field identifying record characteristics",
  "001": "Control Number",
  "003": "Control Number Identifier",
  "005": "Date And Time Of Latest Transaction",
  "006": "Fixed-Length Data Elements--Additional Material Characteristics",
  "007": "Physical Description Fixed Field",
  "008": "Fixed-Length Data Elements--General Information",
  "010": "Library Of Congress Control Number",
  "013": "Patent Control Information",
  "015": "National Bibliography Number",
  "016": "National Bibliographic Agency Control Number",
  "017": "Copyright or Legal Deposit Number",
  "018": "Copyright Article-Fee Code",
  "020": "International Standard Book Number (ISBN)",
  "022": "International Standard Serial Number (ISSN)",
  "024": "Other Standard Identifier",
  "025": "Overseas Acquisition Number",
  "026": "Fingerprint Identifier",
  "027": "Standard Technical Report Number",
  "028": "Publisher or Distributor Number",
  "030": "CODEN Designation",
  "031": "Musical Incipits Information",
  "032": "Postal Registration Number",
  "033": "Date/Time and Place of an Event",
  "034": "Coded Cartographic Mathematical Data",
  "035": "System Control Number",
  "036": "Original Study Number for Computer Data Files",
  "037": "Source of Acquisition",
  "038": "Record Content Licensor",
  "040": "Cataloging Source",
  "041": "Language Code",
  "042": "Authentication Code",
  "043": "Geographic Area Code",
  "044": "Country of Publishing/Producing Entity Code",
  "045": "Time Period of Content",
  "046": "Special Coded Dates",
  "047": "Form of Musical Composition Code",
  "048": "Number of Musical Instruments or Voices Code",
  "050": "Library of Congress Call Number",
  "051": "Library of Congress Copy, Issue, Offprint Statement",
  "052": "Geographic Classification",
  "055": "Classification Numbers Assigned in Canada",
  "060": "National Library of Medicine Call Number",
  "061": "National Library of Medicine Copy Statement",
  "066": "Character Sets Present",
  "070": "National Agricultural Library Call Number",
  "071": "National Agricultural Library Copy Statement",
  "072": "Subject Category Code",
  "074": "GPO Item Number",
  "080": "Universal Decimal Classification Number",
  "082": "Dewey Decimal Classification Number",
  "083": "Additional Dewey Decimal Classification Number",
  "084": "Other Classification Number",
  "085": "Synthesized Classification Number Components",
  "086": "Government Document Classification Number",
  "088": "Report Number",
  100: "Main Entry - Personal Name",
  110: "Main Entry - Corporate Name",
  111: "Main Entry - Meeting Name",
  130: "Main Entry - Uniform Title",
  210: "Abbreviated Title",
  222: "Key Title",
  240: "Uniform Title",
  242: "Translation of Title by Cataloging Agency",
  243: "Collective Uniform Title",
  245: "Title Statement",
  246: "Varying Form of Title",
  247: "Former Title",
  250: "Edition Statement",
  254: "Musical Presentation Statement",
  255: "Cartographic Mathematical Data",
  256: "Computer File Characteristics",
  257: "Country of Producing Entity",
  258: "Philatelic Issue Data",
  260: "Publication, Distribution, etc. (Imprint)",
  261: "Imprint Statement for Films (Pre-AACR 1 Revised)",
  262: "Imprint Statement for Sound Recordings (Pre-AACR 2)",
  263: "Projected Publication Date",
  264: "Production, Publication, Distribution, Manufacture, and Copyright Notice",
  270: "Address",
  300: "Physical Description",
  306: "Playing Time",
  307: "Hours, etc.",
  310: "Current Publication Frequency",
  321: "Former Publication Frequency",
  336: "Content Type",
  337: "Media Type",
  338: "Carrier Type",
  340: "Physical Medium",
  342: "Geospatial Reference Data",
  343: "Planar Coordinate Data",
  344: "Sound Characteristics",
  345: "Projection Characteristics of Moving Image",
  346: "Video Characteristics",
  347: "Digital File Characteristics",
  348: "Format of Notated Music",
  351: "Organization and Arrangement of Materials",
  352: "Digital Graphic Representation",
  353: "Supplementary Content Characteristics",
  355: "Security Classification Control",
  357: "Originator Dissemination Control",
  362: "Dates of Publication and/or Sequential Designation",
  363: "Normalized Date and Sequential Designation",
  365: "Trade Price",
  366: "Trade Availability Information",
  370: "Associated Place",
  377: "Associated Language",
  380: "Form of Work",
  381: "Other Distinguishing Characteristics of Work or Expression",
  382: "Medium of Performance",
  383: "Numeric Designation of Musical Work",
  384: "Key",
  400: "Series Statement/Added Entry--Personal Name",
  410: "Series Statement/Added Entry--Corporate Name",
  411: "Series Statement/Added Entry--Meeting Name",
  440: "Series Statement/Added Entry--Title - Obsolete, 2008",
  490: "Series Statement",
  500: "General Note",
  501: "With Note",
  502: "Dissertation Note",
  504: "Bibliography, etc. Note",
  505: "Formatted Contents Note",
  506: "Restrictions on Access Note",
  507: "Scale Note for Graphic Material",
  508: "Creation/Production Credits Note",
  510: "Citation/References Note",
  511: "Participant or Performer Note",
  513: "Type of Report and Period Covered Note",
  514: "Data Quality Note",
  515: "Numbering Peculiarities Note",
  516: "Type of Computer File or Data Note",
  518: "Date/Time and Place of an Event Note",
  520: "Summary, Abstract, Annotation, Scope, etc.",
  521: "Target Audience Note",
  522: "Geographic Coverage Note",
  524: "Preferred Citation of Described Materials Note",
  525: "Supplement Note",
  526: "Study Program Information Note",
  530: "Additional Physical Form Available Note",
  533: "Reproduction Note",
  534: "Original Version Note",
  535: "Location of Originals/Duplicates Note",
  536: "Funding Information Note",
  538: "System Details Note",
  540: "Terms Governing Use and Reproduction Note",
  541: "Immediate Source of Acquisition Note",
  542: "Information Relating to Copyright Status",
  544: "Location of Other Archival Materials Note",
  545: "Biographical or Historical Data",
  546: "Language Note",
  547: "Former Title Complexity Note",
  550: "Issuing Body Note",
  552: "Entity and Attribute Information Note",
  555: "Cumulative Index/Finding Aids Note",
  556: "Information About Documentation Note",
  561: "Ownership and Custodial History",
  562: "Copy and Version Identification Note",
  563: "Binding Information",
  565: "Case File Characteristics Note",
  567: "Methodology Note",
  580: "Linking Entry Complexity Note",
  581: "Publications About Described Materials Note",
  583: "Action Note",
  584: "Accumulation and Frequency of Use Note",
  585: "Exhibitions Note",
  586: "Awards Note",
  588: "Source of Description Note",
  600: "Subject Added Entry - Personal Name",
  610: "Subject Added Entry - Corporate Name",
  611: "Subject Added Entry - Meeting Name",
  630: "Subject Added Entry - Uniform Title",
  647: "Subject Added Entry - Named Event",
  648: "Subject Added Entry - Chronological Term",
  650: "Subject Added Entry - Topical Term",
  651: "Subject Added Entry - Geographic Name",
  653: "Index Term - Uncontrolled",
  654: "Subject Added Entry - Faceted Topical Terms",
  655: "Index Term - Genre/Form",
  656: "Index Term - Occupation",
  657: "Index Term - Function",
  658: "Index Term - Curriculum Objective",
  662: "Subject Added Entry - Hierarchical Place Name",
  700: "Added Entry - Personal Name",
  710: "Added Entry - Corporate Name",
  711: "Added Entry - Meeting Name",
  720: "Added Entry - Uncontrolled Name",
  730: "Added Entry - Uniform Title",
  740: "Added Entry - Uncontrolled Related/Analytical Title",
  751: "Added Entry - Geographic Name",
  752: "Added Entry - Hierarchical Place Name",
  753: "System Details Access to Computer Files",
  754: "Added Entry - Taxonomic Identification",
  760: "Main Series Entry",
  762: "Subseries Entry",
  765: "Original Language Entry",
  767: "Translation Entry",
  770: "Supplement/Special Issue Entry",
  772: "Supplement Parent Entry",
  773: "Host Item Entry",
  774: "Constituent Unit Entry",
  775: "Other Edition Entry",
  776: "Additional Physical Form Entry",
  777: "Issued With Entry",
  780: "Preceding Entry",
  785: "Succeeding Entry",
  786: "Data Source Entry",
  787: "Other Relationship Entry",
  800: "Series Added Entry - Personal Name",
  810: "Series Added Entry - Corporate Name",
  811: "Series Added Entry - Meeting Name",
  830: "Series Added Entry - Uniform Title",
  850: "Holding Institution",
  852: "Location",
  853: "Captions and Pattern - Basic Bibliographic Unit",
  854: "Captions and Pattern - Supplementary Material",
  855: "Captions and Pattern - Indexes",
  856: "Electronic Location and Access",
  857: "Electronic Archive Location and Access",
  880: "Alternate Graphic Representation",
  882: "Replacement Record Information",
  883: "Machine-generated Metadata Provenance",
  884: "Description Conversion Information",
  885: "Matching Information",
  886: "Foreign MARC Information Field",
  887: "Non-MARC Information Field",
};

export const subfieldDescriptions = {
  a: "Main entry/primary data",
  b: "Secondary information",
  c: "Statement of responsibility/additional info",
  d: "Date",
  e: "Relator term",
  f: "Date of work",
  n: "Number of part/section",
  p: "Name of part/section",
  q: "Qualifier",
  t: "Title",
  u: "URL/Affiliation",
  v: "Volume/designation",
  x: "ISSN",
  z: "Public note",
  2: "Source",
};

export const indicatorInfo = {
  100: {
    ind1: { 0: "Forename", 1: "Surname", 3: "Family name" },
  },
  245: {
    ind1: { 0: "No title added entry", 1: "Title added entry" },
    ind2: {
      0: "No nonfiling characters",
      "1-9": "Number of nonfiling characters",
    },
  },
  650: {
    ind1: { 0: "No info", 1: "Primary subject", 2: "Secondary subject" },
    ind2: { 0: "LC Subject Headings", 7: "Source in $2" },
  },
  700: {
    ind1: { 0: "Forename", 1: "Surname", 3: "Family name" },
    ind2: { " ": "No info provided", 2: "Analytic entry" },
  },
};
